import { useGoodsDetail } from '../../../../../queries/useGoodsDetail';
import { ContentWebView } from '../../ContentWebView';
import {
  Flex,
  IconArrowDown,
  PrimaryButton,
  useScreenSize,
} from '@banhala/ui-kit';
import { WhiteLinearGradient } from '../../WhiteLinearGradient';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLogClickGoodsDetailLoadMore } from '../hooks/useLogClickGoodsDetailLoadMore';
import { BottomProductInfoView } from './BottomProductInfoView';

const FOLDED_HEIGHT_MULTIPLIER = 2;
const BOTTOM_GRADIENT_HEIGHT = 156;

export const GoodsInfoWebView: React.FC<{
  onChangeHeight: (height: number) => void;
}> = props => {
  const { data: goodsDetail } = useGoodsDetail();
  const { height: screenHeight } = useScreenSize();
  const foldedHeight = screenHeight * FOLDED_HEIGHT_MULTIPLIER;
  const onChangeHeightRef = useRef(props.onChangeHeight);
  onChangeHeightRef.current = props.onChangeHeight;

  const [folded, setFolded] = useState(true);
  const [init, setInit] = useState(false);
  const [unfoldedHeight, setUnfoldedHeight] = useState(foldedHeight);
  const logClickGoodsDetailLoadMore = useLogClickGoodsDetailLoadMore();

  useEffect(() => {
    if (init) return;
    setInit(true);
    onChangeHeightRef.current(foldedHeight + BOTTOM_GRADIENT_HEIGHT);
  }, [init, foldedHeight]);

  useEffect(() => {
    if (!folded) {
      onChangeHeightRef.current(unfoldedHeight);
    }
  }, [folded, unfoldedHeight]);

  const html = useMemo(() => {
    if (!goodsDetail) return '';

    const productInfoIframe = goodsDetail.goods.detail_html_parts.filter(
      htmlPart => htmlPart.html_part_type === 'PRODUCT_INFO',
    );
    const html = productInfoIframe[0].contents[0];

    return goodsDetail.goods.detail_html.replace(html, '');
  }, [goodsDetail]);

  return (
    <Flex height={folded ? foldedHeight : unfoldedHeight} overflow={'hidden'}>
      <ContentWebView
        source={{ html }}
        onChangeHeight={setUnfoldedHeight}
        maxHeight={folded ? foldedHeight + BOTTOM_GRADIENT_HEIGHT : undefined}
        Footer={folded ? undefined : <BottomProductInfoView />}
      />
      {folded && (
        <Flex
          height={BOTTOM_GRADIENT_HEIGHT}
          position={'absolute'}
          bottom={0}
          left={0}
          right={0}
          justifyContent={'flex-end'}
        >
          <Flex position={'absolute'} left={0} right={0} bottom={0}>
            <WhiteLinearGradient />
          </Flex>
          <Flex
            padding={{ left: 16, right: 16, bottom: 24 }}
            backgroundColor={'bg_always_white'}
          >
            <PrimaryButton
              variant={'fill'}
              onPress={() => {
                setFolded(false);
                logClickGoodsDetailLoadMore();
              }}
              size={'large'}
              testID={'상품정보펼치기버튼'}
              rightIcon={<IconArrowDown />}
              color={'blue'}
              outline
            >
              상품 정보 펼쳐보기
            </PrimaryButton>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
